import type { PropsWithChildren } from "react";

import { useHasScopePermission } from "app/hooks";
import { NotFound } from "app/views/NotFound";

export function AdminRoute({ children }: PropsWithChildren) {
  const hasPermission = useHasScopePermission();
  const isAdmin = hasPermission("system", "EDIT");

  if (!isAdmin) {
    return <NotFound />;
  }

  return children;
}
